import React from 'react'
import Header from '../header/Header'
import Footer from '../footer/Footer'
import { motion } from 'framer-motion'
import LeftMenu from '../header/LeftMenu'
import { pageVariant } from '../../animations/pageVariant'

const CMS = ({ children }) => {
    return (
        <div>
            <div className='main'>
                <LeftMenu />
                <div className='main-right'>
                    <Header />
                    <motion.div {...pageVariant}>
                        {children}
                    </motion.div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default CMS
